import { Component, inject, OnInit, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router } from '@angular/router';
import { UserService } from '../../services/user.service';
import { TokenService } from '../../services/token.service';

/**
 * UserProfileAvatarComponent
 * * Displays the current user's initials in a circular avatar.
 * * Toggles a dropdown menu with user details and logout functionality.
 */
@Component({
  selector: 'app-user-profile-avatar',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './user-profile-avatar.component.html',
  styles: []
})
export class UserProfileAvatarComponent implements OnInit {
  private userService = inject(UserService);
  private tokenService = inject(TokenService);
  private router = inject(Router);

  // --- UI State ---
  /** Holds the currently logged-in user's details */
  currentUser = signal<any>(null);
  
  /** Controls visibility of the dropdown menu */
  isProfileMenuOpen = signal(false);

  ngOnInit() {
    this.fetchCurrentUser();
  }

  /**
   * Fetches the current user details using the ID from the token.
   */
  fetchCurrentUser() {
    const userId = this.tokenService.getUserIdFromToken();
    if (userId) {
      this.userService.getUserById(userId).subscribe({
        next: (user) => this.currentUser.set(user),
        error: (err) => console.error('Failed to load current user for avatar', err)
      });
    }
  }

  /**
   * Toggles the visibility of the profile menu.
   */
  toggleProfileMenu() {
    this.isProfileMenuOpen.update(v => !v);
  }

  /**
   * Logs out the user by clearing the token and redirecting to login.
   */
  logout() {
    this.tokenService.clearToken();
    this.router.navigate(['/login']);
  }
}